import React from "react";
import {Controller, useFieldArray, useFormContext} from "react-hook-form";

import {StyledDetailContainer, StyledDetailTable} from "../../styledComponents/StyledDetail";
import MWCaption from "../../components/MWCaption";
import {FormContents} from "../../styledComponents/StyledCreateForm";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextareaAutosize,
  styled,
  TextField,
} from "@mui/material";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";

import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {initializeEvaluationStep} from "../../models/serverModels/permission/WPEvaluationStep";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {useSetRecoilState} from "recoil";

const Textarea = styled(TextareaAutosize)(({theme}) => ({
  width: "100%",
  padding: "8px",
  fontSize: "14px",
  lineHeight: 1.4,
  letterSpacing: "0.02rem",
  resize: "none",
}));

const VerticalCheckBox = styled(FormControlLabel)(({theme}) => ({
  padding: "0",
  "& .MuiFormControlLabel-label": {fontSize: "14px"},
  "& .MuiSvgIcon-root": {fontSize: 16},
  "& .css-1f3gig2-MuiButtonBase-root-MuiCheckbox-root": {padding: "4px"},
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const EvaluationMasterForm = ({captionColor}: SubTitleColorProps) => {
  const setAlertState = useSetRecoilState(alertStateAtom);

  const {departmentList} = useDepartmentList();

  const methods = useFormContext();

  const {getValues, control} = methods;

  const {fields, append, remove} = useFieldArray({
    name: "evaluationSteps",
    control,
  });

  const updateHandler = () => {
    if (fields.length < 7) {
      append(initializeEvaluationStep());
    }
    return;
  };

  return (
    <React.Fragment>
      <StyledDetailContainer>
        <MWCaption title={"위험성평가 작성"} color={captionColor} icon={<SpellcheckIcon />} />
        <FormContents container rowSpacing={4}>
          <StyledDetailTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" width="10%">
                    일련번호
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    {getValues("serialMessage")}
                  </TableCell>
                  <TableCell component="th" width="20%">
                    부서명
                  </TableCell>
                  <TableCell component="td" width="46.66%">
                    {departmentList?.items.map((value) =>
                      value.uid === getValues("departmentUID") ? value.name : ""
                    )}
                  </TableCell>
                  {/* <TableCell component="th" width="10%">
                    평가자
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    <Controller
                      name="evaluator"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <Textarea defaultValue={value} onChange={onChange} minRows={1} />
                      )}
                    />
                  </TableCell> */}
                </TableRow>

                {/* <TableRow>
                  <TableCell component="th">개정일</TableCell>
                  <TableCell component="td">
                    <Controller
                      name="revisionDate"
                      control={control}
                      render={({field, ...props}) => (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat={"yyyy년 MM월 dd일"}
                            value={field.value}
                            onChange={(date) => {
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id="revisionDate"
                                size="small"
                                margin="dense"
                                sx={{width: "100%"}}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">개정번호</TableCell>
                  <TableCell component="td">{getValues("serialNo")}</TableCell>
                  <TableCell component="th">개정사유</TableCell>
                  <TableCell component="td">
                    <Controller
                      name="reason"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <Textarea defaultValue={value} onChange={onChange} minRows={1} />
                      )}
                    />
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell component="th">취급물질</TableCell>
                  <TableCell component="td" align="right">
                    <Controller
                      name="material"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <Textarea defaultValue={value} onChange={onChange} minRows={1} />
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">내용</TableCell>
                  <TableCell component="td" colSpan={3}>
                    <Controller
                      name="contents"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <Textarea defaultValue={value} onChange={onChange} minRows={1} />
                      )}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </StyledDetailTable>
        </FormContents>
      </StyledDetailContainer>
      {/* <StyledDetailContainer>
        <MWCaption title={"위험성평가 작성 2"} color={captionColor} icon={<SpellcheckIcon />}>
        </MWCaption>
        <FormContents container rowSpacing={4}>
          <StyledDetailTable>
            <Table>
              <TableHead style={{backgroundColor: "#f0fafa"}}>
                <TableRow>
                  <TableCell align="center">#</TableCell>
                  <TableCell align="center">작업단계</TableCell>
                  <TableCell align="center">유해위험요인</TableCell>
                  <TableCell align="center">대책(안전작업방법)</TableCell>
                  <TableCell align="center" width="15%">
                    필요허가서
                  </TableCell>
                  <TableCell align="center" width="5%">
                    삭제
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fields?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">
                      <Controller
                        name={`evaluationSteps.${index}.workStep`}
                        control={control}
                        render={({field, fieldState: {error}}) => (
                          <>
                            <Textarea
                              {...field}
                              minRows={8}
                              required
                              placeholder="작업단계를 입력하세요"
                            />
                          </>
                        )}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Controller
                        name={`evaluationSteps.${index}.hazardFactor`}
                        control={control}
                        render={({field}) => (
                          <Textarea
                            {...field}
                            minRows={8}
                            required
                            placeholder="유해위험요인을 입력하세요"
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Controller
                        name={`evaluationSteps.${index}.solution`}
                        control={control}
                        render={({field}) => (
                          <Textarea
                            {...field}
                            minRows={8}
                            required
                            placeholder="대책(안전작업방법)을 입력하세요"
                          />
                        )}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Box display="flex" flexDirection="column">
                        <Controller
                          name={`evaluationSteps.${index}.isFireWork`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="화기작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isClosed`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="밀폐작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isExcavation`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="굴착작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isHeavy`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="중장비작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isHeight`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="고소작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isRadiation`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="방사선작업허가"
                            />
                          )}
                        />
                        <Controller
                          name={`evaluationSteps.${index}.isStopElectricity`}
                          control={control}
                          render={({field}) => (
                            <VerticalCheckBox
                              control={
                                <Checkbox
                                  onChange={(e) => field.onChange(e.target.checked)}
                                  checked={field.value}
                                />
                              }
                              label="정전작업허가"
                            />
                          )}
                        />
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => {
                          setAlertState({
                            toggle: true,
                            message: "작업단계를 삭제하시겠습니까?",
                            execution: () => remove(index),
                          });
                        }}
                      >
                        삭제
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </StyledDetailTable>
          <Button
            variant="contained"
            size="small"
            color="info"
            onClick={updateHandler}
            sx={{marginLeft: "auto", marginTop: "32px", marginRight: "16px"}}
          >
            작업단계 추가
          </Button>
        </FormContents>
      </StyledDetailContainer> */}
    </React.Fragment>
  );
};

export default EvaluationMasterForm;
